import React, { useEffect, useState } from 'react';
import { oneOfType, string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { RentalServices } from './RentalServices';

export const RentalServicesContainer = ({ timeout, ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="rental-services">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <RentalServices {...props} />
    </QueryProvider>
  );
};

RentalServicesContainer.propTypes = {
  timeout: oneOfType([string, number])
};

RentalServicesContainer.defaultProps = {
  timeout: '3000'
};
